<template>
  <v-expansion-panel @click.stop="selectComponent(model)"
    :class="[{'dr-expansion-panel-item-selected': isSelected}, evaluateClasses(classes)]"
  >
    <portal to="action-buttons" v-if="isSelected">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn :disabled="readonly" v-on="on" text color="error" @click="onDeletePanelItem">
            <font-awesome-icon :icon="['fal', 'trash-alt']" size="lg" />
          </v-btn>
        </template>
        <span>{{ $t("vuetifyWidgets.common.remove") }}</span>
      </v-tooltip>
    </portal>
    <v-expansion-panel-header>
      <div>
        <v-icon v-if="model.IconName" :color="model.IconColor">{{ model.IconName }}</v-icon>
        {{ model.Text }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <draggable
        v-if="isInEditorMode"
        :class="[evaluateClasses(classes), 'dr-expansion-panel-item']"
        :group="{ name:'container', put:['toolbox', 'container'] }"
        :swapThreshold="0.95"
        :emptyInsertThreshold="20"
        :disabled="readonly"
        @add="onWidgetDraggableAdd"
        @update="onModelChanged"
        :list="model.Widgets"
      >
      <component
        v-for="widget in model.Widgets || []"
        :key="widget.$ID"
        :is="widget.$Type"
        :readonly="readonly"
        :parentsWidgets="currentListOfParentsWidgets"
        :model="widget"
        @modelChanged="onModelChanged"
        @deleteComponent="onDeletePanelItemComponent"
        :dataSource="dataSource" @callDataSourceAction="$emit('callDataSourceAction', $event)"
      />
    </draggable>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import contextMenuMixin from '../../mixins/contextmenu-mixin'

export default {
  mixins: [mixin, contextMenuMixin, inputMixin],
  methods: {
    onDeletePanelItem() {
      this.$emit('onDeletePanelItem', this.model)
      this.widgetsHelper.setSelectedWidget(undefined)
    },
    onDeletePanelItemComponent(widget) {
      let index = this.model.Widgets.indexOf(widget)
      if (index === -1) {
        return
      }
      this.model.Widgets.splice(index, 1)
      this.onModelChanged()
    },
    onModelChanged() {
      this.$emit('modelChanged', this.model)
    }
  }
}
</script>
<style>
.dr-expansion-panel-item{ 
  min-height: 50px;
  border: 1px solid #a9a9a9;
}
.dr-expansion-panel-item-selected {
  outline: 2px solid #ffa500;
  outline-offset: -2px;
}
</style>
